module.exports = __webpack_public_path__ + "img/wind.6bd198fb.svg";